import {
  ToolTipRegion,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';

const ToolTip = ({
  content,
  onShow,
  targetText,
}) => (
  <ToolTipRegion
    arrowSide="left"
    arrowEdge="top"
    content={content}
    onShow={onShow}
  >
    <span>{targetText}</span>
  </ToolTipRegion>
);

ToolTip.defaultProps = {
  onShow: () => {}
};

ToolTip.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  onShow: PropTypes.func,
  targetText: PropTypes.string.isRequired,
};

export default ToolTip;